import { render, staticRenderFns } from "./WechatMenus.vue?vue&type=template&id=69c70440&scoped=true&"
import script from "./WechatMenus.vue?vue&type=script&lang=js&"
export * from "./WechatMenus.vue?vue&type=script&lang=js&"
import style0 from "./WechatMenus.vue?vue&type=style&index=0&id=69c70440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c70440",
  null
  
)

export default component.exports